<nz-upload [nzBeforeUpload]="beforeUpload" class="image-upload" [nzAccept]="['image/jpg', 'image/png', 'image/jpeg']">
  <img *ngIf="fileUrl" class="preview-upload-image" [src]="fileUrl || urlImage || '/assets/images/logo.PNG'" alt="">
  <ng-container *ngIf="!fileUrl && urlImage">
    <img [src]="urlImage" [ngClass]="'image-current'" alt=""/>
  </ng-container>
  <div *ngIf="!fileUrl && !urlImage" class="hint-upload">
    <i class="upload-icon" nz-icon [nzType]="uploading ? 'loading' : 'plus'" aria-hidden="true"></i>
    <div class="ant-upload-text">Tải ảnh lên</div>
  </div>
</nz-upload>
<!--<button (click)="handleUpload()">upload</button>-->
